import {LinkToOfferBannerDefaultBox} from "./link-to-offer-banner.default.box";

export const LinkToOfferBannerBox = LinkToOfferBannerDefaultBox;
